export { default } from './part-feature-item';
